import { render, staticRenderFns } from "./_cookie-collection-templates.vue?vue&type=template&id=23ea109c"
import script from "./_cookie-collection-templates.vue?vue&type=script&lang=js"
export * from "./_cookie-collection-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports